module.exports = __webpack_public_path__ + "img/dibs.699fef2.svg";